import React from 'react'
import { Section } from '@components/Sections/Section'
import type { FAQAccordionSectionProps } from '@/types/components/faq'
import './SectionFAQAccordion.scss'
import { FAQAccordion } from '../FAQ/FAQAccordion'

export const SectionFAQAccordion: React.FC<FAQAccordionSectionProps> = ({
  content,
}) => {
  const { _id, header, items, theme } = content

  return (
    <Section theme={theme} id={_id}>
      <div className="faq-section-accordion">
        <div className="faq-section-accordion__inner">
          <h5 className="faq-section-accordion__title type-h2">{header}</h5>

          <div className="faq-section-accordion__body">
            <FAQAccordion items={items} />
          </div>
        </div>
      </div>
    </Section>
  )
}
